import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./AuthSlice";
import EmployeesSlice from "./EmployeesSlice";
import HomeSlice from "./HomeSlice";
import SettingsSlice from "./SettingsSlice";
import ContractSlice from "./ContractSlice";

export default configureStore({
  reducer: {
    AuthSlice,
    EmployeesSlice,
    HomeSlice,
    SettingsSlice,
    ContractSlice,
  },
});
